const cards = [
  {
    num: '01',
    title: 'Precios económicos',
    text: 'Nuestra principal ventaja: materiales de acero al mejor precio de la región. Optimiza el costo de tu proyecto sin sacrificar calidad.',
  },
  {
    num: '02',
    title: 'Amplio inventario',
    text: 'Perfiles estructurales, varilla, lámina, PTR, ángulos y más — todo disponible en nuestras instalaciones en Tepatitlán.',
  },
  {
    num: '03',
    title: 'Atención rápida',
    text: 'Abiertos de lunes a viernes de 8:30 a 17:00 y sábados hasta las 14:00, adaptados a la jornada laboral de nuestros clientes.',
  },
  {
    num: '04',
    title: 'Para profesionales',
    text: 'Atendemos a constructores, herreros, soldadores y talleres de metalmecánica con servicio y asesoría personalizados.',
  },
];

export default function WhyUs() {
  return (
    <section className="whyus">
      <div className="container">
        <div className="section-header">
          <p className="section-overline">Por qué elegirnos</p>
          <h2 className="section-title light">Nuestras Ventajas</h2>
          <div className="section-divider" />
        </div>

        <div className="whyus-cards">
          {cards.map(({ num, title, text }) => (
            <div key={num} className="whyus-card-v2">
              <span className="whyus-card-num">{num}</span>
              <div className="whyus-card-body">
                <h3 className="whyus-card-title">{title}</h3>
                <p className="whyus-card-text">{text}</p>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}
